import { useEffect, useRef } from "react";
import Typed from "typed.js";

// components
import DarkMode from "../../components/DarkMode/DarkMode";
import Modal from "../../components/Modal/Modal";

// style
import "./Home.css";
import profile from "../../assets/img/profile.png";
import Resume from "../../assets/files/resume.pdf";

const Home = () => {
	// Create Ref element.
	const el = useRef(null);
	useEffect(() => {
		document.title = "Home";

		const typed = new Typed(el.current, {
			strings: ["Back-end Developer", "Front-end Developer", "Cloud Engineer"], // Strings to display
			// Speed settings, try diffrent values untill you get good results			startDelay: 300,
			typeSpeed: 45,
			backSpeed: 25,
			loop: true,
		});

		// Destropying
		return () => {
			typed.destroy();
		};
	}, []);
	return (
		<>
			<section id="main" className="home-main">
				<div className="container-fluid container-main">
					<DarkMode />
					<div className="row">
						<div className="col-lg-8 col-sm-12 order-2 order-lg-1 title-text">
							<h4 className="greeting">Hi, my name is</h4>
							<h1>Muhammad Faisal Hidayatullah</h1>
							<h3 className="sub-title">
								And I'm a <span className="blue" ref={el}></span>
							</h3>
							<form
								method="get"
								action={Resume}
								className="d-flex flex-wrap justify-content-between pe-5 title-button"
							>
								<button type="submit" className="btn btn-primary btn-lg">
									Download CV
								</button>
								{/* <!-- Button trigger modal --> */}
								<button
									type="button"
									className="btn btn-see-details"
									data-bs-toggle="modal"
									data-bs-target="#exampleModal"
								>
									{"See details >"}
								</button>
							</form>
						</div>
						<div className="col-lg-4 col-sm-12 order-1 order-lg-2">
							<img className="title-image" src={profile} alt="Faisal" />
						</div>
					</div>
				</div>
			</section>
			<Modal title="My Profile">
				I'm a tech-enthusiastic computer engineer student with a deep interest in Web Development,
				Software Engineer, and Cloud Computing. I have some experience working in project including
				create Website (frontend & backend), APIs, and Cloud Architecture.
			</Modal>
		</>
	);
};

export default Home;
